// extracted by mini-css-extract-plugin
export var parcelRow = "_w4-0";